export default __webpack_public_path__ + "static/media/charter_italic-webfont.a831186e.woff";